import { render, staticRenderFns } from "./StaffDashboard.vue?vue&type=template&id=258b64ea"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports